const registrationPlugin = (state = {}, {type, payload}) => {
  switch (type) {
    case 'REGISTRATION_PLUGIN.INIT':
      return { ...state, ...payload }
    default:
      return state
  }
}

export default registrationPlugin
